import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { SurveyRoutes } from "../utils/routes.utils";

export const SurveyRedirectPage = () => {
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get("t");

  useEffect(() => {
    // Log the redirect for debugging if needed
    if (import.meta.env.NODE_ENV === "development") {
      console.log("Short survey redirect with token:", inviteToken);
    }
  }, [inviteToken]);

  if (!inviteToken) {
    // If no token, redirect to a 404 or error page
    return <Navigate to="/404" replace />;
  }

  // Redirect to the full survey start URL with the token
  const redirectUrl = `${SurveyRoutes.START_SURVEY}?invite_token=${inviteToken}`;
  return <Navigate to={redirectUrl} replace />;
};
